/**
 * 게시판 관리 서비스
 */

import { apiClient } from '../../../shared/services/api';
import { BoardItem, BoardListItem } from '../../../shared/types/board.types';

export interface BoardFormData {
  title: string;
  content: string;
  deleteFileIds?: number[];
}

interface PaginationResponse<T> {
  data: T[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export const boardService = {
  /**
   * 게시글 목록 조회
   */
  getPosts: async (boardType: string, page: number = 1, limit: number = 10): Promise<PaginationResponse<BoardListItem>> => {
    const response = await apiClient.get<{ data: PaginationResponse<BoardListItem> }>(`/board/${boardType}?page=${page}&limit=${limit}`);
    return response.data;
  },

  /**
   * 게시글 상세 조회
   */
  getPost: async (boardType: string, id: number): Promise<BoardItem> => {
    const response = await apiClient.get<{ data: BoardItem }>(`/board/detail/${id}`);
    return response.data;
  },

  /**
   * 게시글 생성
   */
  createPost: async (boardType: string, data: BoardFormData, files?: File[]): Promise<{ id: number; boardType: string; title: string }> => {
    const formData = new FormData();

    // 필드 데이터 추가
    formData.append('title', data.title);
    formData.append('content', data.content);

    // 파일 추가
    if (files && files.length > 0) {
      files.forEach(file => {
        formData.append('files', file);
      });
    }

    const response = await apiClient.post<{ data: { id: number; boardType: string; title: string } }>(
      `/board/${boardType}`,
      formData
    );
    return response.data;
  },

  /**
   * 게시글 수정
   */
  updatePost: async (boardType: string, id: number, data: BoardFormData, files?: File[]): Promise<{ id: number; boardType: string; title: string }> => {
    const formData = new FormData();

    // 필드 데이터 추가
    formData.append('title', data.title);
    formData.append('content', data.content);

    // 삭제할 파일 ID 추가
    if (data.deleteFileIds && data.deleteFileIds.length > 0) {
      data.deleteFileIds.forEach(fileId => {
        formData.append('deleteFileIds', fileId.toString());
      });
    }

    // 파일 추가
    if (files && files.length > 0) {
      files.forEach(file => {
        formData.append('files', file);
      });
    }

    const response = await apiClient.put<{ data: { id: number; boardType: string; title: string } }>(
      `/board/${boardType}/${id}`,
      formData
    );
    return response.data;
  },

  /**
   * 게시글 삭제
   */
  deletePost: async (boardType: string, id: number): Promise<void> => {
    await apiClient.delete(`/board/${boardType}/${id}`);
  },
};
